import { Icon } from "@shared/components/Icon.tsx";
import { Logo } from "@shared/components/Logo.tsx";
import { toDeva } from "@shared/lib/format.ts";
import { ABOUT, CONTACT, FAQ } from "../content/about.ts";
import { PageBanner } from "../Layout.tsx";

export function AboutPage() {
  const hasContact = CONTACT.address || CONTACT.phones.length || CONTACT.email;
  return (
    <>
      <PageBanner title="संपर्क" />
      <div className="container content content--narrow">
        <article className="about-header">
          <h2 className="section-title about-title">
            <Logo size={56} /> {ABOUT.heading}
          </h2>
          {ABOUT.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
          <a className="text-link" href={ABOUT.mainSite}>
            संस्थेच्या मुख्य संकेतस्थळाला भेट द्या{" "}
            <Icon name="external" size={16} />
          </a>
        </article>

        <aside className="contact-card contact-card--standalone" aria-labelledby="contact-h">
          <h2 id="contact-h">संपर्क</h2>
          {hasContact ? (
            <ul className="contact-list">
              {CONTACT.address && (
                <li>
                  <Icon name="pin" size={20} />
                  <span className="address-text">{CONTACT.address}</span>
                </li>
              )}
              {CONTACT.phones.map((p) => (
                <li key={p.number}>
                  <Icon name="phone" size={20} />
                  <span>
                    <strong>{p.label}</strong><br></br>
                    <a
                      href={`tel:${p.number.replace(/\s/g, "")}`}
                      className="selectable"
                    >
                      {toDeva(p.number)}
                    </a>
                  </span>
                </li>
              ))}
              {CONTACT.email && (
                <li>
                  <Icon name="mail" size={20} />
                  <a href={`mailto:${CONTACT.email}`} className="selectable">
                    {CONTACT.email}
                  </a>
                </li>
              )}
              {CONTACT.hours && (
                <li>
                  <Icon name="calendar" size={20} />
                  <span>{CONTACT.hours}</span>
                </li>
              )}
            </ul>
          ) : (
            <p className="muted">
              स्पर्धेसाठी संपर्क तपशील लवकरच येथे दिले जातील.
            </p>
          )}
          <a className="btn btn-secondary btn-md" href={CONTACT.contactPage}>
            <span>मुख्य संकेतस्थळावरील संपर्क पान</span>
            <Icon name="external" size={16} />
          </a>
        </aside>

        {FAQ.length > 0 && (
          <section className="section">
            <h2 className="section-title">नेहमी विचारले जाणारे प्रश्न</h2>
            <div className="faq">
              {FAQ.map((f) => (
                <details key={f.q} className="faq-item">
                  <summary>
                    <span>{f.q}</span>
                    <Icon name="chevronDown" size={20} />
                  </summary>
                  <p>{f.a}</p>
                </details>
              ))}
            </div>
          </section>
        )}
      </div>
    </>
  );
}
